import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="dhiwise-navigation">
      <h1>Homepage</h1>
      <p className="headline">
        This project was generated By{" "}
        <a href="https://www.dhiwise.com">Dhiwise</a>. Quickly use below links
        to navigate through all pages.
      </p>
      <ul>
        <li>
          <Link to="/">Adminaddcompany</Link>
        </li>
        <li>
          <Link to="/admindashboardone">AdmindashboardOne</Link>
        </li>
        <li>
          <Link to="/adminfeedback">Adminfeedback</Link>
        </li>
        <li>
          <Link to="/invite">invite</Link>
        </li>
        <li>
          <Link to="/adminfeedbackthree">AdminfeedbackThree</Link>
        </li>
        <li>
          <Link to="/admincreateboard">Admincreateboard</Link>
        </li>
        <li>
          <Link to="/adminroadmap">Adminroadmap</Link>
        </li>
        <li>
          <Link to="/admineditroadmap">Admineditroadmap</Link>
        </li>
        <li>
          <Link to="/adminusers">Adminusers</Link>
        </li>
        <li>
          <Link to="/adminsettings">Adminsettings</Link>
        </li>
        <li>
          <Link to="/adminchangelog">Adminchangelog</Link>
        </li>
        <li>
          <Link to="/userroadmap">Userroadmap</Link>
        </li>
        <li>
          <Link to="/admineditdashboard">Admineditdashboard</Link>
        </li>
        <li>
          <Link to="/usercreatepost">Usercreatepost</Link>
        </li>
        <li>
          <Link to="/admindashboard">Admindashboard</Link>
        </li>
        <li>
          <Link to="/userpostdetails">Userpostdetails</Link>
        </li>
        <li>
          <Link to="/one">One</Link>
        </li>
        <li>
          <Link to="/login">login</Link>
        </li>
        <li>
          <Link to="/three">Three</Link>
        </li>
        <li>
          <Link to="/four">Four</Link>
        </li>
        <li>
          <Link to="/usernotifications">Usernotifications</Link>
        </li>
        <li>
          <Link to="/adminnotifications">Adminnotifications</Link>
        </li>
        <li>
          <Link to="/five">Five</Link>
        </li>
        <li>
          <Link to="/six">Six</Link>
        </li>
        <li>
          <Link to="/seven">Seven</Link>
        </li>
        <li>
          <Link to="/eight">Eight</Link>
        </li>
        <li>
          <Link to="/nine">Nine</Link>
        </li>
      </ul>
    </div>
  );
};

export default Home;
